module.exports = __webpack_public_path__ + "img/conformPas.f16bfaca.svg";